import { gql } from '@apollo/client'

export default gql(`
    mutation deleteUsers($id: [String] $project: String) {
        deleteUsers(
            input: $id
            project: $project
        ){
            id
        }
    }
`)
